import type { ShortlistFeedbackApi } from '../../../api/shortlist-feedback/shortlistFeedback.api';
import type { WithServices } from '../../../platform/ts/services';
import type { WithErrorService } from '../../front/ErrorService/ErrorService';
import type { WithMessageService } from '../../internal/MessageService/MessageService';
import type { ShortlistFeedbackMutationService } from './ShortlistFeedbackMutationService';

/**
 * No v1 action follows: the v4 public page's votes never sent one either, and the internal pages
 * pick feedback up from the server's realtime event. The effect names the block: a guest's page
 * knows the shortlist only by its link.
 */
export function createShortlistFeedbackMutationService(
  config: WithServices<[WithMessageService, WithErrorService]> & {
    api: ShortlistFeedbackApi;
  }
): ShortlistFeedbackMutationService {
  const {
    api,
    services: { messageService, errorService }
  } = config;
  const interceptor = errorService.withCategory(
    'ShortlistFeedbackMutationService'
  );

  async function written(blockId: number) {
    await messageService.reportSystemEffect.sendRequest(
      {
        scope: [
          {
            entity: 'shortlistBlock',
            entityId: blockId,
            payload: { type: 'update' }
          }
        ]
      },
      3000
    );
  }

  return {
    vote: interceptor.wrap(async (target, vote) => {
      await api.vote(target, vote);
      await written(target.blockId);
    }),
    comment: interceptor.wrap(async (target, text) => {
      await api.comment(target, text);
      await written(target.blockId);
    })
  };
}
